import React from 'react';
import {Grid, Typography} from '@material-ui/core';
import {observer} from 'mobx-react-lite';
import {Quote} from '../../../Core/mobx/ParameterStore/Quote';
import Card from '@material-ui/core/Card';
import {NumberFormatCustom, TextBox} from '../../../Core/UI';
import {Parameter} from '../../../Core/mobx/ParameterStore/ParameterStore';
import {SelectInputElement} from '../../PreQualification/Components/SelectInputElement';
import {FormType} from '../../PreQualification/types';
import {fieldOptions} from '../../../Core/mobx/ParameterStore/QuoteXref';

type GuaranteedTabProps = {
    valueChanged: (p?: Parameter, value?: any, formType?: FormType) => void;
    parameters: Quote;
    formType: FormType;
};

const GuaranteedTab = observer(({valueChanged, parameters, formType}: GuaranteedTabProps) => {
    const required = (value?: string) => (
        <span>
            {value && value} <span style={{color: 'red'}}>*</span>
        </span>
    );

    return (
        <>
            <Card
                style={{
                    padding: 20,
                    marginBottom: 20,
                }}
            >
                <div>
                    <Typography style={{fontWeight: 'bold', fontSize: 24}}>Carrier Product</Typography>
                </div>
                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <SelectInputElement
                            param={{
                                label: 'Product',
                                name: 'productGuaranteed',
                                options: fieldOptions.productGuaranteed.options,
                                ...parameters.productGuaranteed,
                            }}
                            required={required('')}
                            valueChanged={valueChanged}
                            formType={formType}
                        />
                        <small>MOO age 45 - 85; Gerber age 50 - 80; Great Western age 40 - 49</small>
                    </Grid>
                </Grid>
            </Card>
            {parameters.moo.value && (
                <Card
                    style={{
                        padding: 20,
                        marginBottom: 20,
                    }}
                >
                    <div>
                        <Typography style={{fontWeight: 'bold', fontSize: 24}}>Basics</Typography>
                    </div>
                    <Grid container spacing={3}>
                        <Grid item xs={6}>
                            <SelectInputElement
                                param={{
                                    label: 'Health Rating',
                                    name: 'healthRatingMOO',
                                    options: fieldOptions.healthRatingMOO.options,
                                    ...parameters.healthRatingMOO,
                                }}
                                required={''}
                                valueChanged={valueChanged}
                                formType={formType}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <SelectInputElement
                                param={{
                                    label: 'Smoker Status',
                                    name: 'smokerRatingMOO',
                                    options: fieldOptions.smokerRatingMOO.options,
                                    ...parameters.smokerRatingMOO,
                                }}
                                required={''}
                                valueChanged={valueChanged}
                                formType={formType}
                            />
                        </Grid>
                    </Grid>
                </Card>
            )}
            <Card
                style={{
                    padding: 20,
                    marginBottom: 20,
                }}
            >
                <div>
                    <Typography style={{fontWeight: 'bold', fontSize: 24}}>Coverage and Premium</Typography>
                </div>
                <Grid container spacing={3}>
                    {parameters.moo.value && (
                        <Grid item xs={6}>
                            <TextBox
                                id={'specifiedFaceAmountMOO'}
                                label={required('Specified Face Amount')}
                                value={parameters.specifiedFaceAmountMOO?.value}
                                onChange={(value) => valueChanged(parameters.specifiedFaceAmountMOO, value, undefined)}
                                InputProps={{
                                    inputComponent: NumberFormatCustom,
                                }}
                            />
                            <small>Max $40K for level and $20K for graded</small>
                        </Grid>
                    )}
                    {parameters.productGuaranteed.value === 'GerberFinalExpense' && (
                        <Grid item xs={6}>
                            <SelectInputElement
                                param={{
                                    label: 'Specified Face Amount',
                                    name: 'specifiedFaceAmountTransGerber',
                                    options: fieldOptions.specifiedFaceAmountTransGerber.options,
                                    ...parameters.specifiedFaceAmountTransGerber,
                                }}
                                required={required('')}
                                valueChanged={valueChanged}
                                formType={formType}
                            />
                        </Grid>
                    )}
                    {parameters.productGuaranteed.value === 'GreatWesternFinalExpense' && (
                        <Grid item xs={6}>
                            <SelectInputElement
                                param={{
                                    label: 'Specified Face Amount',
                                    name: 'specifiedFaceAmountGW',
                                    options: fieldOptions.specifiedFaceAmountGW.options,
                                    ...parameters.specifiedFaceAmountGW,
                                }}
                                required={required('')}
                                valueChanged={valueChanged}
                                formType={formType}
                            />
                        </Grid>
                    )}
                    <Grid item xs={6}>
                        <SelectInputElement
                            param={{
                                label: 'Premium Payment Frequency',
                                name: 'premiumFrequency',
                                options: fieldOptions.premiumFrequency.options,
                                optionValues: fieldOptions.premiumFrequency.optionValues,
                                ...parameters.premiumFrequency,
                            }}
                            required={''}
                            valueChanged={valueChanged}
                            formType={formType}
                        />
                    </Grid>
                </Grid>
            </Card>
        </>
    );
});

export default GuaranteedTab;
